import { getUserFromToken } from '@/utils/tokenUtils';
import api from '@/services/axios';
import { setAccessToken } from '@/services/tokenStore';

export function getTokenClaims() {
  return getUserFromToken();
}

/**
 * Получает статус онбординга из токена (без запроса к серверу)
 * ОТКЛЮЧЕНО: онбординг больше не используется
 */
export function getOnboardingStatus() {
  // Всегда возвращаем show: false, чтобы отключить онбординг
    return { show: false, version: 0, progress: {} };
}

/**
 * Отмечает шаг онбординга как выполненный и обновляет токен
 */
export async function markOnboardingStep(stepId, done = true) {
  try {
    const { data } = await api.post('/onboarding/step', { stepId, done });
    if (data && data.access_token) {
      // Обновляем токен с новым прогрессом (в памяти)
      setAccessToken(data.access_token);
      
      if (stepId === 'market_research' && done === true) {
        setTimeout(() => {
          if (window.location.pathname.includes('/market_research/')) {
            window.location.href = '/my_market_research';
          }
        }, 500);
      }
    }
  } catch (error) {
    console.error('Error in markOnboardingStep:', error);
  }
}

/**
 * Завершает онбординг и обновляет токен
 */
export async function completeOnboarding(version) {
  try {
    const { data } = await api.post('/onboarding/complete', { version });
    if (data && data.access_token) {
      // Обновляем токен без изменения роли (в памяти)
      setAccessToken(data.access_token);
    }
    return true;
  } catch (_) {
    return false;
  }
}

/**
 * Сбрасывает онбординг (полностью или частично) и обновляет токен
 */
export async function resetOnboarding(stepIds = null) {
  try {
    const payload = stepIds ? { stepIds } : {};
    const { data } = await api.post('/onboarding/reset', payload);
    if (data && data.access_token) {
      setAccessToken(data.access_token);
    }
    return true;
  } catch (_) {
    return false;
  }
}

/**
 * Проверяет, нужно ли показать тур по навбару (синхронно из токена)
 * ОТКЛЮЧЕНО: онбординг больше не используется
 */
export function shouldShowNavbarTour() {
  return false;
}

/**
 * Проверяет, нужно ли показать тур по SmartSearch (синхронно из токена)
 * ОТКЛЮЧЕНО: онбординг больше не используется
 */
export function shouldShowSmartSearchTour() {
  return false;
}

/**
 * Проверяет, нужно ли показать тур по маркет ресерчу (синхронно из токена)
 * ОТКЛЮЧЕНО: онбординг больше не используется
 */
export function shouldShowMarketResearchTour() {
  return false;
}

/**
 * Проверяет, нужно ли показать онбординг для указанного шага
 * ОТКЛЮЧЕНО: онбординг больше не используется
 */
export function shouldShowOnboarding() {
  return false;
}

/**
 * Проверяет, завершен ли онбординг для указанного шага
 */
export function isOnboardingCompleted(stepId) {
  const status = getOnboardingStatus();
  if (!status.progress) return false;
  return status.progress[stepId] === true;
}


